<!-- Header -->
<div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mx-3 -mt-3">
  <h2 class="mb-0 text-sm" aria-label="folder-dialog-header">
    {{ activeFolder?('ADMIN.DOCUMENT.UPDATE_FOLDER' | translate)
    :('ADMIN.DOCUMENT.ADD_NEW_FOLDER' | translate) }}
  </h2>
  <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="close()" aria-label="close-folder-dialog"></div>
</div>
<!-- Header -->
<form #form="ngForm" *ngIf="folderForm" [formGroup]="folderForm" (ngSubmit)="saveFolderForm()" aria-label="folder-form">
  <!-- Content -->
  <div class="surface-100 p-3 text-sm -mx-3 w-22rem md:w-30rem">
    <div class="mb-3">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="folder-name-primary-label">
        {{ 'ADMIN.DOCUMENT.FOLDER_NAME' | translate }} 
        <span *ngIf="secondaryLanguage">({{ primaryLanguage | translate }})</span>
      </label>
      <input formControlName="name_primary_language" type="text" class="w-full text-sm" pInputText placeholder="Name"
             aria-label="folder-name-primary-input" />
      <app-error-msg *ngIf="Primary?.touched && NamePrimary?.invalid" [errors]="Primary?.errors"
        [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_NAME' | translate"></app-error-msg>
    </div>

    <div class="mb-3">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="folder-description-primary-label">
        {{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }} 
        <span *ngIf="secondaryLanguage">({{ primaryLanguage | translate }})</span>
      </label>
      <textarea formControlName="description_primary_language" pInputTextarea class="w-full h-4rem"
        placeholder="{{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }}"
        aria-label="folder-description-primary-input"></textarea>
      <app-error-msg *ngIf="Primary?.touched && NamePrimary?.invalid" [errors]="Primary?.errors"
        [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_NAME' | translate"></app-error-msg>
    </div>

    <div class="mb-3" *ngIf="isSecondaryLanguage | async">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="folder-name-secondary-label">
        {{ 'ADMIN.DOCUMENT.FOLDER_NAME' | translate }}
        <span *ngIf="isSecondaryLanguage | async">({{ SecondaryLanguage }})</span>
      </label>
      <input formControlName="name_secondary_language" type="text" class="w-full text-sm" pInputText
        placeholder="Name" aria-label="folder-name-secondary-input" />
      <app-error-msg *ngIf="Secondary?.touched && Secondary?.invalid" [errors]="Secondary?.errors"
        [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_DESC' | translate"></app-error-msg>
    </div>

    <div class="" *ngIf="isSecondaryLanguage | async">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="folder-description-secondary-label">
        {{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate}} 
        <span *ngIf="isSecondaryLanguage | async">({{ SecondaryLanguage }})</span>
      </label>
      <textarea formControlName="description_secondary_language" pInputTextarea class="w-full h-4rem"
        placeholder="{{ 'ADMIN.DOCUMENT.FOLDER_DESC' | translate }}"
        aria-label="folder-description-secondary-input"></textarea>
      <app-error-msg *ngIf="SecondaryDesc?.touched && SecondaryDesc?.invalid" [errors]="SecondaryDesc?.errors"
        [fieldLabel]="'ADMIN.DOCUMENT.FOLDER_DESC' | translate"></app-error-msg>
    </div>
  </div>
  <!-- Content -->

  <!-- Footer -->
  <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300 -mx-3 -mb-3">
    <button pButton pRipple type="button" label="{{ 'ADMIN.COMMON.CANCEL' | translate }}" class="p-button-text text-sm"
      (click)="close()" aria-label="cancel-folder-dialog-button"
      data-testid="cancel-folder-dialog-button"></button>
    <button [loading]="isSubmitting" pButton pRipple type="submit"
      label="{{ activeFolder? ('ADMIN.DOCUMENT.UPDATE_FOLDER' | translate) :('ADMIN.DOCUMENT.ADD_NEW_FOLDER' | translate) }}"
      class="text-sm" aria-label="submit-folder-dialog-button"
      data-testid="submit-folder-dialog-button"></button>
  </div>
  <!-- Footer -->
</form>